import { render, staticRenderFns } from "./MigrationFromAnotherSystem.vue?vue&type=template&id=6e4ec334&scoped=true"
import script from "./MigrationFromAnotherSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./MigrationFromAnotherSystem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MigrationFromAnotherSystem.vue?vue&type=style&index=0&id=6e4ec334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ec334",
  null
  
)

export default component.exports